export default __webpack_public_path__ + "static/media/medium.8fe4f99a.svg";